module.exports = __webpack_public_path__ + "img/SketchPngd423b18a224d17a556a80aadcb3a8bf761c7b058cfbe3c013d9d67edbabd95ba.1ff04c29.png";